<template>
  <div>
    <span
      v-if="status == 'preparing' || status == 'running'"
      class="orange--text"
    >
      Processing
    </span>
    <span v-else-if="status == 'complete'" class="green--text">OK</span>
    <span v-else-if="status == 'failed'" class="red--text">Failed</span>
    <span v-else></span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
    },
  },
}
</script>
